import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
   selector: 'app-goals-form',
   templateUrl: './goals-form.component.html',
   styleUrls: ['./goals-form.component.scss'],
})
export class GoalsFormComponent implements OnInit {
   taskForm: FormGroup;
   minFromDate = new Date();
   minToDate = new Date();
   maxDate: Date = new Date(2999, 11, 31);
   isEdit = false;
   constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<GoalsFormComponent>, private formBuilder: FormBuilder) {}

   ngOnInit(): void {
      if (this.data !== null) {
         this.isEdit = true;
         this.patchForm();
      } else {
         this.taskForm = this.formBuilder.group({
            goal: ['' /*[Validators.required]*/],
            activities: ['' /* [Validators.required]*/],
            timeframe: ['' /* [Validators.required]*/],
            responsiblePerson: ['' /*[Validators.required]*/],
         });
      }
      this.taskForm.get('timeframe').valueChanges.subscribe((timeframe: Date) => {
         this.minToDate = timeframe;
      });
   }

   closeDialog() {
      this.dialogRef.close({ event: 'Cancel' });
   }

   addNewTask() {
      this.dialogRef.close({ event: 'Create', data: this.taskForm.value });
   }
   editTask() {
      this.dialogRef.close({ event: 'Edit', data: this.taskForm.value });
   }

   checkDate(control: string, event: any) {
      if (event.value === null) {
         this.taskForm.get(control).reset();
      }
   }
   patchForm() {
      this.taskForm = this.formBuilder.group({
         goal: this.data.goal,
         activities: this.data.activities,
         timeframe: this.data.timeframe,
         responsiblePerson: this.data.responsiblePerson,
      });
   }
}
